import React, { useState, useRef, useEffect } from 'react';
import { FaComments, FaTimes, FaPaperPlane } from 'react-icons/fa';
import './Chatbot.css';

const portfolioData = {
  name: "Mudassir Khattak",
  education: "Graduated Software Engineer",
  experience: "1+ year professional experience in Software Quality Assurance",
  projects: [
    "Feel Pro App (Mobile)",
    "Amal App (Mobile)",
    "Mashoor App (Mobile)",
    "Kids Diary App (Mobile)",
    "AI_SDLC (SAAS)",
    "MVP 100 Hours (Web)",
    "ThinkBusinessOnly (Web)",
    "Dot App (Web)",
    "Guess Chat App (Mobile)",
    "Auto Silent App (Mobile)",
    "And more"
  ],
  skills: [
    "Manual Testing",
    "Automation Testing",
    "Performance Testing",
    "API Testing",
    "Test Planning",
    "Defect Tracking"
  ],
  tools: [
    "Selenium",
    "Jira",
    "JMeter",
    "NeoLoad",
    "Katalon Studio",
    "And more"
  ],
  contact: {
    email: "maidizone@gmail.com",
    github: "github.com/Mudassirsami",
    linkedin: "linkedin.com/in/mudassirkhan",
    location: "Wah Cantt, Pakistan"
  }
};

const suggestedQuestions = [
  "What is your education?",
  "How much experience do you have?",
  "List your projects",
  "What skills do you have?",
  "Which tools do you use?",
  "How can I contact you?"
];

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      type: 'bot',
      text: `Hi! I'm Mudassir's portfolio assistant. Ask me about my professional profile.`
    }
  ]);
  const [inputValue, setInputValue] = useState('');
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const getResponse = (query) => {
    const lowerQuery = query.toLowerCase();

    if (lowerQuery.includes('name') || lowerQuery.includes('who are you')) {
      return `My name is ${portfolioData.name}.`;
    }

    if (lowerQuery.includes('education') || lowerQuery.includes('degree') || lowerQuery.includes('graduate') || lowerQuery.includes('study')) {
      return `I am a ${portfolioData.education}.`;
    }

    if (lowerQuery.includes('experience') || lowerQuery.includes('years of experience')) {
      return `I have ${portfolioData.experience}.`;
    }

    if (lowerQuery.includes('project') || lowerQuery.includes('work')) {
      return `Here are my projects:\n\n${portfolioData.projects.map((project, index) => `${index + 1}. ${project}`).join('\n')}`;
    }

    if (lowerQuery.includes('skill')) {
      return `My skills include:\n\n${portfolioData.skills.map((skill, index) => `${index + 1}. ${skill}`).join('\n')}`;
    }

    if (lowerQuery.includes('tool') || lowerQuery.includes('testing tools')) {
      return `I use the following tools:\n\n${portfolioData.tools.map((tool, index) => `${index + 1}. ${tool}`).join('\n')}`;
    }

    if (lowerQuery.includes('contact') || lowerQuery.includes('email') || lowerQuery.includes('linkedin') || lowerQuery.includes('github') || lowerQuery.includes('location')) {
      return `You can reach me at:\n\nEmail: ${portfolioData.contact.email}\nGitHub: ${portfolioData.contact.github}\nLinkedIn: ${portfolioData.contact.linkedin}\nLocation: ${portfolioData.contact.location}`;
    }

    return "I can only answer questions related to my professional portfolio.";
  };

  const handleSend = (messageText = inputValue) => {
    if (!messageText.trim()) return;

    const userMessage = { type: 'user', text: messageText };
    const botResponse = { type: 'bot', text: getResponse(messageText) };

    setMessages(prev => [...prev, userMessage, botResponse]);
    setInputValue('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleSuggestedQuestion = (question) => {
    handleSend(question);
  };

  return (
    <div className="chatbot-container">
      {!isOpen && (
        <div className="chatbot-toggle-wrapper">
          <span className="chatbot-label">Talk to my assistant</span>
          <button 
            className="chatbot-toggle"
            onClick={() => setIsOpen(true)}
            aria-label="Open chat"
          >
            <FaComments />
          </button>
        </div>
      )}

      {isOpen && (
        <div className="chatbot-window">
          <div className="chatbot-header">
            <div className="chatbot-header-content">
              <FaComments className="chatbot-header-icon" />
              <div>
                <h3>Portfolio Assistant</h3>
                <span className="chatbot-status">Online</span>
              </div>
            </div>
            <button 
              className="chatbot-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close chat"
            >
              <FaTimes />
            </button>
          </div>

          <div className="chatbot-messages">
            {messages.map((message, index) => (
              <div 
                key={index} 
                className={`chatbot-message ${message.type}`}
              >
                <div className="message-bubble">
                  {message.text.split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < message.text.split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>

          <div className="chatbot-suggested">
            {suggestedQuestions.map((question, index) => (
              <button
                key={index}
                className="suggested-question"
                onClick={() => handleSuggestedQuestion(question)}
              >
                {question}
              </button>
            ))}
          </div>

          <div className="chatbot-input">
            <input
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Ask me anything..."
            />
            <button 
              onClick={() => handleSend()}
              aria-label="Send message"
              disabled={!inputValue.trim()}
            >
              <FaPaperPlane />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbot;
